<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <form @change="logChangeData">
        <div class="setting_content_heading">
          <h2 class="setting_content_title">
            {{ labelProperties.HEAD_TITLE }}
          </h2>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ labelProperties.SOCIAL_NAME_SETTING }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ labelProperties.COMPANY_NAME }}</p>
            <div class="setting_unit_form">
              <draggable
                :list="displaySetting.companyPublicSettings"
                draggable=".item"
                @change="logChangeData"
                :group="{ name: 'item-job', put: checkSettingsLength(1) === 0 }"
                @add="addItemToDisplaySetting(1)"
              >
                <div v-for="(companyPublicSetting, index) in displaySetting.companyPublicSettings" :key="index" class="item">
                  <div class="setting_form_wrapper" v-if="companyPublicSetting && !companyPublicSetting.itemResourceDeleted">
                    <input
                      class="setting_form_text" type="text"
                      :placeholder="labelProperties.PLACE_HOLDER"
                      v-model="companyPublicSetting.display_name"
                      readonly
                    />
                    <div class="setting_form_wrapper_close" @click="deleteItemSetting(index, 1)">
                      <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                          <rect fill="#555" width="12" height="12" rx="2" />
                          <g fill="#FFF">
                            <path d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"/>
                            <path d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"/>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div slot="footer" class="setting_form_wrapper" v-if="checkSettingsLength(1) === 0">
                  <input class="setting_form_text" type="text" :placeholder="labelProperties.PLACE_HOLDER" readonly/>
                </div>
              </draggable>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ labelProperties.HOME_PAGE_POSTING_SETTING }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.HOME_PAGE_POSTING }}
            </p>
            <div class="setting_unit_form">
              <draggable
                :list="displaySetting.homepagePostingSettings"
                draggable=".item"
                @change="logChangeData"
                :group="{ name: 'item-job', put: checkSettingsLength(2) === 0 }"
                @add="addItemToDisplaySetting(2)"
              >
                <div v-for="(homepagePosting, index) in displaySetting.homepagePostingSettings" :key="index" class="item">
                  <div class="setting_form_wrapper" v-if="homepagePosting && !homepagePosting.itemResourceDeleted">
                    <input
                      class="setting_form_text"
                      type="text"
                      :placeholder="labelProperties.PLACE_HOLDER"
                      v-model="homepagePosting.display_name"
                      readonly
                    />
                    <div class="setting_form_wrapper_close" @click="deleteItemSetting(index, 2)">
                      <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                          <rect fill="#555" width="12" height="12" rx="2" />
                          <g fill="#FFF">
                            <path d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"/>
                            <path d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"/>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div slot="footer" class="setting_form_wrapper" v-if="checkSettingsLength(2) === 0">
                  <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="labelProperties.PLACE_HOLDER"
                    readonly
                    @change="logChangeData"
                  />
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </form>
    </div>
    <DragDropComponent
      :groupName="groupName"
      :jobCategories="jobCategories"
      :property="property"
      :resourceFields="resourceFields"
      @updatedProperty="updatedProperty"
      @refreshResourceList="refreshResourceList"
      @getJobResourceFields="getJobResourceFields"
      :useType="useType"
      :idSetScroll="idSetScroll"
      :isDispatch="true"
    />
  </div>
</template>

<script>
import DragDropComponent from "./DragDropComponent.vue";
import draggable from "vuedraggable";
import DisplaySettingLabels from "../../../../properties/job_screen/display_setting_tab/display-setting-labels.json";
import generalService from "../../../../services/GeneralService";
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";
import * as generalLabels from "../../../../properties/general_page/generalpage-labels.json";
import * as jobSettingProperty from "../../../../properties/job_screen/job-screen.json";

const ITEM_SETTING_IN_DISPLAY_SETTING_TAB = 2;
const COMPANY_PUBLIC_SETTING = 1;
const HOMEPAGE_POSTING_SETTING = 2;

export default {
  name: "DisplaySettingsTab",
  components: {
    DragDropComponent,
    draggable,
  },
  props: [
    "displaySetting",
    "groupName",
    "jobCategories",
    "property",
    "resourceFields",
    "useType",
    "userId",
  ],
  data() {
    return {
      labelProperties: DisplaySettingLabels,
      log: {
        info: {},
      },
      idSetScroll: "menu-search-item-setting-dispatch-job-public-settings"
    };
  },
  computed: {
    computedDisplaySetting: {
      get() {
        return this.displaySetting;
      },
      set(val) {
        this.$emit("updatedDisplaySetting", val);
      },
    },
  },
  methods: {
    addItemToDisplaySetting(type) {
      let nameItem = "";
      let displayNameItem = "";
      let companyPublic = [];
      let homepagePostings = [];
      switch (type) {
        case COMPANY_PUBLIC_SETTING:
          this.displaySetting.companyPublicSettings.forEach((item, index) => {
            this.displaySetting.companyPublicSettings[index] = JSON.parse(JSON.stringify(item));
          });

          companyPublic = this.displaySetting.companyPublicSettings.filter(itemSetting => itemSetting && !itemSetting.itemResourceDeleted);
          if (companyPublic && companyPublic.length > 0) {
            nameItem = companyPublic[0].name;
            displayNameItem = companyPublic[0].display_name;
          }

          break;
        case HOMEPAGE_POSTING_SETTING:
          homepagePostings = this.displaySetting.homepagePostingSettings.filter(itemSetting => itemSetting && !itemSetting.itemResourceDeleted);
          this.displaySetting.homepagePostingSettings.forEach((item, index) => {
            this.displaySetting.homepagePostingSettings[index] = JSON.parse(JSON.stringify(item));
          });

          if (homepagePostings && homepagePostings.length > 0) {
            nameItem = homepagePostings[0].name;
            displayNameItem = homepagePostings[0].display_name;
          }

          break;
      }

      this.resourceFields.filter(
          (resource) =>
              resource.name === nameItem &&
              resource.display_name === displayNameItem
      )
          .forEach((resource) => {
            if (!resource.isUsed) {
              resource.isUsed = [];
            }
            resource.isUsed.push(ITEM_SETTING_IN_DISPLAY_SETTING_TAB);
          });
      this.$emit("updateResourceField", JSON.parse(JSON.stringify(this.resourceFields)));
    },

    checkSettingsLength(type) {
      let length = 0;
      if (type === 1 && this.computedDisplaySetting.companyPublicSettings) {
        this.computedDisplaySetting.companyPublicSettings.forEach(
            (companyPublicSetting) => {
              if (companyPublicSetting && !companyPublicSetting.itemResourceDeleted) {
                length++;
              }
            }
        );
      }

      if (type === 2 && this.computedDisplaySetting.homepagePostingSettings) {
        this.computedDisplaySetting.homepagePostingSettings.forEach(homepagePosting => {
              if (homepagePosting && !homepagePosting.itemResourceDeleted) {
                length++;
              }
            }
        );
      }

      return length;
    },

    deleteItemSetting(index, type) {
      if (type === 1 && this.displaySetting.companyPublicSettings[index]) {
        this.displaySetting.companyPublicSettings[index] = JSON.parse(JSON.stringify(this.displaySetting.companyPublicSettings[index]));
        this.displaySetting.companyPublicSettings[index].itemResourceDeleted = true;
        this.refreshItemSetting(this.displaySetting.companyPublicSettings[index].name);
      }

      if (type === 2 && this.displaySetting.homepagePostingSettings[index]) {
        this.displaySetting.homepagePostingSettings[index] = JSON.parse(JSON.stringify(this.displaySetting.homepagePostingSettings[index]));
        this.displaySetting.homepagePostingSettings[index].itemResourceDeleted = true;
        this.refreshItemSetting(this.displaySetting.homepagePostingSettings[index].name);
      }

      this.$eventBus.$emit("unSaved", true);
    },

    refreshItemSetting(resourceName) {
      this.resourceFields.filter((resource) => resource.name === resourceName).forEach(resource => {
        if (!resource.isUsed || resource.isUsed.length <= 0 || !resource.isUsed.includes(ITEM_SETTING_IN_DISPLAY_SETTING_TAB)) {
          return;
        }

        resource.isUsed.splice(resource.isUsed.indexOf(ITEM_SETTING_IN_DISPLAY_SETTING_TAB), 1);
      });

      this.$emit("updateResourceField", JSON.parse(JSON.stringify(this.resourceFields)));
    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    updatedProperty(property) {
      this.$emit("updatedProperty", property);
    },

    async refreshResourceList() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DISPLAY_SETTINGS_TAB_TITLE + "-Click button" + screenLabelsProperties.REFRESH_RESOURCE_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("refreshResourceList", this.log.hash);
    },

    async getJobResourceFields() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DISPLAY_SETTINGS_TAB_TITLE + "-Click button search " + screenLabelsProperties.SEARCH_JOB_LABEL;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("getJobResourceFields", this.log.hash);
    },
  },
};
</script>

<style scoped>

</style>
